import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { GeckoField } from 'ui';

import './index.scss';

// This component will basically wrap a GeckoField in the normal input syntax i.e. no config object, has a value and an onChange function.
class NormalisedGeckoField extends Component {
  // Any additional props will be passed through to the GeckoField
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
  };

  handleChange(_key, value) {
    return this.props.onChange(value);
  }

  render() {
    // We want every prop bar the value and onChange function and the key of "value"
    const field = { key: 'value', ...this.props };
    delete field.value;
    delete field.onChange;

    // Create a synthetic values object for GeckoField
    const values = { value: this.props.value };

    return (
      <div className="NormalisedGeckoField">
        <GeckoField
          field={field}
          values={values}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default NormalisedGeckoField;
